"use client";

import { useParams, usePathname, useSearchParams } from "next/navigation";
import Link from "next/link";

type LinkWrapper = Omit<Parameters<typeof Link>[0], "href" | "id">;

export function KeepSPGameLink({ date, gId, children, ...rest }: { date: string; gId: number } & LinkWrapper) {
  const path = usePathname();
  const params = path.split("/");

  const { year } = useParams();
  const ALLYear = ["2025", "2024", "2023", "2022"] as const;
  const yearComp = ALLYear.find((f) => f === year) || ALLYear[0];

  const searchParams = useSearchParams();
  const isKeep = params.at(-1) === "game";

  const sp = isKeep ? `?${searchParams.toString()}` : "";

  return (
    <Link href={`/${yearComp}/game/${date}/${gId}${sp}`} {...rest} scroll={!isKeep}>
      {children}
    </Link>
  );
}
